import 'css-chunk:src/components/widgets/ContentUploader/Content/ImageContent.scss';export default {
  "ImageContent": "_ImageContent_1nv4y_1",
  "image": "_image_1nv4y_4"
};